import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-expandable', 'expandRow', 'Раскрыть ряд');
Labels.set('ui-table-expandable', 'collapseRow', 'Скрыть ряд');
